/**
 * Form validation utilities
 * 
 * This file contains reusable validation functions for forms.
 */

/**
 * Validates an email address format
 * @param email - The email address to validate
 * @returns True if the email is valid or empty, false otherwise
 */
export const validateEmail = (email: string): boolean => {
  if (!email) {
    // Email is optional, so it's valid if empty
    return true;
  }

  // Simple email validation regex
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/**
 * Validates that two passwords match
 * @param password - The password
 * @param confirmPassword - The confirmation password
 * @returns True if passwords match or either is empty, false otherwise
 */
export const validatePasswords = (password: string, confirmPassword: string): boolean => {
  // Only validate if both fields have values
  if (password && confirmPassword) {
    return password === confirmPassword;
  }
  // If either field is empty, consider it valid (individual field validation should handle required fields)
  return true;
};

/**
 * Validates that a string is not empty
 * @param value - The string to validate
 * @returns True if the string is not empty, false otherwise
 */
export const validateRequired = (value: string): boolean => {
  return !!value;
};

/**
 * Validates that at least one item is selected from an array
 * @param values - The array of selected values
 * @returns True if at least one item is selected, false otherwise
 */
export const validateRequiredArray = (values: any[]): boolean => {
  return Array.isArray(values) && values.length > 0;
};
